//@ts-ignore
//This module is declared with 'export =', and can only be used with a default import when using the 'esModuleInterop' flag.
import React, {ReactElement} from "react";
import {Button, Col, ConfigProvider, Divider, Form, Input, Radio, Row, Space, Typography} from "antd";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {Link, useLocation} from "react-router-dom";
import {getClients} from "../services/ServiceClients";
import IClient from "../interfaces/IClient";
import ClientIcon from "../components/ClientIcon";
import {getAuthentications} from "../services/ServiceAuths";
import IAuthentication from "../interfaces/IAuthentication";
import {useForm} from "@refinedev/antd";
import AuthIcon from "../components/AuthIcon";

export default function Connect(): ReactElement | null {

    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    // Variables
    const query = useQuery();
    const client = query.get("client_id");
    const authsQuery = query.get("auths")

    const { clients } = getClients();
    const { authentications } = getAuthentications();
    const { form, formProps, onFinish } = useForm<any>({
        action: "create",
        resource: `${window.userprofile.path.login}?${query}`
    })

    const auths: IAuthentication[] = (authsQuery?.split(",") ?? []).map(auth => authentications?.find(a => a.id === auth)).filter(auth => auth !== undefined) as IAuthentication[];
    const clientDetails: IClient = clients?.find((cl) => cl.id === client)!;
    const getAuthTypes = (...types: string[]): IAuthentication[] => auths?.filter(auth => types?.includes(auth?.type)) ?? []
    const isAuthType = (type: string): boolean => getAuthTypes(type).length >= 1

    const yes: boolean = isAuthType("yes");
    const no: boolean = isAuthType("no");
    const list: IAuthentication[] = getAuthTypes("file", "ldap");
    const cas: IAuthentication[] = getAuthTypes("cas");
    const lti: IAuthentication[] = getAuthTypes("lti");

    const handleFinish = (values: any) => {
        onFinish(values).then(() => {
            window.top!.location.href = `${window.userprofile.url}/${window.userprofile.path.login}?${query}`;
        }).catch(() => {

        })
    }

    const onClick = () => {
        window.top!.location.href = lti[0].url!;
    }

    return (
        <div className="container">
            <ConfigProvider theme={{token: { colorPrimary: clientDetails?.color ?? "" }}}>
                <Form {...formProps} form={form} onFinish={handleFinish} name="connect" size="large" className="form">
                    <Space direction="vertical">
                        <Col className="icon-col">
                            <ClientIcon client={clientDetails} size={100} />
                        </Col>
                        {(yes || no || list.length > 0) &&
                            <ConfigProvider theme={{token: { colorPrimary: clientDetails?.color ?? "#222222"}}}>
                                <Form.Item name="username" rules={[{ required: true, message: "Entrez un nom d'utilisateur" }]}>
                                    <Input prefix={<UserOutlined />} placeholder="Nom d'utilisateur" />
                                </Form.Item>
                                <Form.Item name="password" rules={[{ required: true, message: "Entrez un mot de passe" }]}>
                                    <Input prefix={<LockOutlined />} type="password" placeholder="Mot de passe" />
                                </Form.Item>
                                <Col>
                                    {(yes || no || list.length === 1)
                                        ?
                                        <Form.Item hidden name="authentication" initialValue={yes ? "yes-yes" : no ? "no-no" : list[0].id}>
                                            <Input hidden/>
                                        </Form.Item>
                                        :
                                        <Form.Item style={{display: "flex", justifyContent: "center"}} name="authentication" rules={[{ required: true, message: "Séléctionnez un moyen d'authentification" }]}>
                                            <Radio.Group>
                                                {list?.map((auth: IAuthentication) => (
                                                    <Radio.Button key={auth.id} value={auth.id}>{auth.name}</Radio.Button>
                                                ))}
                                            </Radio.Group>
                                        </Form.Item>
                                    }
                                    <Form.Item>
                                        <Button block htmlType="submit" type="primary">Connexion</Button>
                                    </Form.Item>
                                </Col>
                            </ConfigProvider>
                        }
                        {(!yes && !no && list.length > 0 && cas.length > 0) &&
                            <Divider/>
                        }
                        {(!yes && !no) &&
                            <>
                                {cas.map(authCas => (
                                    <ConfigProvider key={authCas.id} theme={{token: { colorPrimary: authCas?.color ?? clientDetails?.color }}}>
                                        <Col>
                                            <Button block icon={<AuthIcon auth={authCas}/>} href={`${window.userprofile.path.cas}/${authCas.id}?${query}`} type="primary" target="_blank">
                                                {authCas.name}
                                            </Button>
                                        </Col>
                                    </ConfigProvider>
                                ))}
                            </>
                        }
                        {(!yes && !no && list.length === 0 && cas.length === 0 && lti.length > 0) &&
                            <Col>
                                <Row justify="center">Veuillez vous connecter via cette plateforme :</Row>
                                <Row justify="center">
                                    <Typography.Text onClick={onClick} style={{color: clientDetails?.color ?? "", cursor: "pointer"}}>
                                        {lti[0].name}
                                    </Typography.Text>
                                </Row>
                            </Col>
                        }
                    </Space>
                </Form>
            </ConfigProvider>
        </div>
    );
}
